import { z } from "zod/v4";

import { SubscriptionProductDtoSchema } from "../dtos/stripe-api";

export const SubscriptionProductFeSchema = SubscriptionProductDtoSchema.extend({
  isActive: z.boolean(),
});

export type SubscriptionProductFeType = z.infer<
  typeof SubscriptionProductFeSchema
>;
